import {MainIndex} from '../../screensComponents/IndexScreen/MainIndex';

const IndexComponent = () => {
  return (
    <MainIndex />
  );
};

export default IndexComponent;
